import { createAction, props } from "@ngrx/store"
import { IExame } from "src/app/shared/interfaces/exames/iexame";

enum ExameActionType {
    LOAD_EXAME = '[exame] load exame from api',
    LOAD_EXAME_SUCCESS = '[exame] load exame from api return success',
    LOAD_EXAME_ERROR = '[exame] load exame from api return error',

    LOAD_EXAM_BY_ID = '[exame] load exame by ID',
    LOAD_EXAM_BY_ID_SUCCESS = '[exame] load exame by ID return success',

    SAVE_EXAME = '[exame] save exame from api',
    SAVE_EXAME_SUCCESS = '[exame] save exame from api return success',
    SAVE_EXAME_ERROR = '[exame] save exame from api return error',

    EDIT_EXAME = '[exame] edit exame from api',
    EDIT_EXAME_SUCCESS = '[exame] edit exame from api return success',
    EDIT_EXAME_ERROR = '[exame] edit exame from api return error',

    DELETE_EXAME = '[exame] delete exame from api',
}


const loadExame = createAction(
    ExameActionType.LOAD_EXAME
);

const loadExameSuccess = createAction(
    ExameActionType.LOAD_EXAME_SUCCESS,
    props<{ lista: any }>()
);

const loadExameError = createAction(
    ExameActionType.LOAD_EXAME_ERROR
);

const loadExameByID = createAction(
    ExameActionType.LOAD_EXAM_BY_ID,
    props<{id: any}>()
);

const loadExameByIDSuccess = createAction(
    ExameActionType.LOAD_EXAM_BY_ID_SUCCESS,
    props<{exam: IExame}>()
);

const saveExame = createAction(
    ExameActionType.SAVE_EXAME,
    props<{ exame: IExame }>()
)

const saveExameSuccess = createAction(
    ExameActionType.SAVE_EXAME_SUCCESS
    
)

const saveExameError = createAction(
    ExameActionType.SAVE_EXAME_ERROR
)

const editExame = createAction(
    ExameActionType.EDIT_EXAME,
    props<{ exame: IExame, id: number }>()
)

const editExameSuccess = createAction(
    ExameActionType.EDIT_EXAME_SUCCESS
    
)

const editExameError = createAction(
    ExameActionType.EDIT_EXAME_ERROR
)

const deleteExame = createAction(
    ExameActionType.DELETE_EXAME,
    props<{ id: number }>()
)

export const exameActions = {
    loadExame,
    loadExameSuccess,
    loadExameError,
    saveExame,
    saveExameSuccess,
    saveExameError,
    editExame,
    editExameSuccess,
    editExameError,
    deleteExame,
    loadExameByID,
    loadExameByIDSuccess
}